/**
 * Main List Collections JavaScript for MegaRTL
 */

document.addEventListener('DOMContentLoaded', () => {
    const collectionCards = document.querySelectorAll('.tz-collection-card');

    collectionCards.forEach((card, index) => {
        // Basic interaction feedback
        card.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                card.click();
            }
        });

        // Staggered reveal if needed in future
    });
});
